module.exports = __webpack_public_path__ + "img/3.f4348a72.webp";